import { useEffect, useState } from "react";
import { useApiCall } from "./useApiCall";

export const usePostReview = () => {
  const { executeApiCall, apiCallResponse, apiCallStatus } = useApiCall();
  const [isPostingReview, setIsPostingReview] = useState(false);
  const [postedReview, setPostedReview] = useState();
  const [postReviewError, setPostReviewError] = useState();

  const postReview = (review) => {
    setPostReviewError();
    setPostedReview();

    let url = `/reviews/${review?.productId}`;

    const requestOptions = {
      url,
      method: "POST",
      data: review,
    };

    setIsPostingReview(true);
    executeApiCall(requestOptions);
  };

  useEffect(() => {
    switch (apiCallStatus) {
      case "success":
        if (apiCallResponse.data.error) {
          setPostReviewError(apiCallResponse.data.error.userMessage);
          setIsPostingReview(false);
        } else {
          setPostReviewError();

          if (apiCallResponse.data.data) {
            const { review } = apiCallResponse.data.data;

            setIsPostingReview(false);
            setPostedReview(review);
          }
        }
        break;
      case "error":
        setIsPostingReview(false);
    }
  }, [apiCallStatus, apiCallResponse]);

  return { isPostingReview, postReview, postedReview, postReviewError };
};
